export default 'Cas clients réels et documentés : primes CEE, rénovation copropriété, courtage énergie, CEE agricoles. Chiffres vérifiables, dossiers signés.';
